module.exports = __webpack_public_path__ + "img/trunk_9x2.826cf51f.svg";